import t from "./translator";
import apiCall from "./api-call";

export { t, apiCall };
